export const UserManagementTableColumns = [
  // { key: 'sn', label: 'SN' },
  { key: 'action', label: 'Action' },
  { key: 'Email', label: 'User ID' },
  { key: 'Initials', label: 'Initials' },
  { key: 'UserRole', label: 'Role' },
  { key: 'status', label: 'Status' },
];
